import { Link } from "react-router-dom";
import { AppLogo } from "@/components/atoms/AppLogo";
import { SiteFooter } from "@/components/layout/SiteFooter";

type AuthLayoutProps = {
  title: string;
  subtitle: string;
  footer?: React.ReactNode;
  children: React.ReactNode;
};

export function AuthLayout({ title, subtitle, footer, children }: AuthLayoutProps) {
  return (
    <div className="flex min-h-screen flex-col bg-page text-white">
      <header className="px-6 py-6">
        <Link to="/" className="text-sm text-white/70 transition-colors hover:text-white">
          ← Back
        </Link>
      </header>

      <main className="mx-auto w-full max-w-md flex-1 px-6 pb-16">
        <AppLogo to="/" size={36} className="mb-2" />
        <h1 className="mt-6 text-2xl font-bold">{title}</h1>
        <p className="mt-2 text-sm text-white/70">{subtitle}</p>
        <div className="mt-8">{children}</div>
        {footer ? <div className="mt-6 text-center text-sm text-white/55">{footer}</div> : null}
      </main>

      <SiteFooter variant="compact" />
    </div>
  );
}
